var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 116,
    viewBox: "0 0 32 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.032 0c-.568 11.962 6.44 24.588 21.028 37.88 14.587 13.29 14.587 26.867 0 40.727C7.04 90.57.032 102.911.032 115.632V0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    opacity: 0.598,
    transform: "translate(5 51)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    y: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    y: 14,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.f808f0ed2fa9e5b40cddf3b303eed582.svg";
export { ForwardRef as ReactComponent };